import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/content/newsflash',
  owner: '/home',
  authority: 'newsflashList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};